import React from "react";
import { useT } from "./i18n/context";
import { LegalPage } from "./i18n/LegalPage";

export function Impressum() {
  const { impressum } = useT();
  return <LegalPage title={impressum.title} sections={impressum.sections} />;
}
